import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../lib/common/components/CustomCard";
import { Button } from "../lib/common/components/CustomButton";

export default function AuthError() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const [errorDescription, setErrorDescription] = useState("");

  useEffect(() => {
    const error = searchParams.get("error");
    setError(error || "Unknown Error");

    // Map error codes to user-friendly messages
    let description = "";
    switch (error) {
      case "Configuration":
        description =
          "There is a problem with the server configuration. Please contact the administrator.";
        break;
      case "AccessDenied":
        description =
          "You do not have permission to sign in. Please contact your administrator for access.";
        break;
      case "Verification":
        description =
          "The verification process failed. Please try signing in again.";
        break;
      case "OAuthSignin":
        description =
          "There was an issue signing in with your OAuth provider. Please try again.";
        break;
      default:
        description = "An unknown error occurred. Please try again later.";
    }
    setErrorDescription(description);
  }, [searchParams]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f6f9f7] p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center text-red-600">
            Authentication Error
          </CardTitle>
          <CardDescription className="text-center font-semibold">
            {error}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="mb-4">{errorDescription}</p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Link to="/auth/signin">
            <Button>Return to Sign In</Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
